import { cva } from 'class-variance-authority';

import { SURFACE_BASE } from '../surface/variants';

const variant = {
  neutral: 'border-neutral-border',
  secondary: 'border-secondary',
  success: 'border-success',
  warning: 'border-warning',
  destructive: 'border-destructive',
};

export type CardVariant = keyof typeof variant;

const headerVariant = {
  neutral: 'bg-muted-minimal',
  secondary: 'bg-secondary-minimal',
  success: 'bg-success-minimal',
  warning: 'bg-warning-minimal',
  destructive: 'bg-destructive-minimal',
};

export const cardVariants = cva(
  `${SURFACE_BASE} text-neutral-foreground overflow-hidden shadow flex grow flex-col gap-4 transition-colors duration-300`,
  {
    variants: {
      variant,
    },
    defaultVariants: {
      variant: 'neutral',
    },
  }
);

export const cardHeaderVariants = cva(
  'p-4 gap-x-2 rounded-t-xl [.border-b]:pb-6 group/card-header @container/card-header grid auto-rows-min items-center has-data-[slot=card-action]:grid-cols-[1fr_auto] has-data-[slot=card-description]:grid-rows-[auto_auto]',
  {
    variants: {
      variant: headerVariant,
    },
    defaultVariants: {
      variant: 'neutral',
    },
  }
);
